import type { CSSProperties } from "react";

/**
 * Vue 브리지 컨테이너의 인라인 스타일.
 *
 * 본 프로젝트는 Vue → React 마이그레이션 중인 hybrid SPA 다. React-native 경로
 * (`/game`, `/settings`, `/documents/*`)에서는 사용자에게 React
 * 컴포넌트만 보여야 하지만, Vue 앱을 unmount 하면 그 안에서 생성된 Pinia store
 * (solver 결과, AI Setup config 등)가 함께 사라진다.
 *
 * 그래서 React-native 경로에서는 Vue 앱을 mount 상태로 유지(=Pinia 보존)하되
 * `display: none` 으로 시각 트리만 숨긴다. `display: none` 은 레이아웃/페인트 비용과
 * React 페이지와의 시각 충돌·pointer/focus 가로채기를 제거하면서도 Vue 인스턴스는
 * 그대로 살려둔다.
 */
export function vueBridgeContainerStyle(hidden: boolean): CSSProperties {
  return {
    width: "100%",
    height: "100%",
    display: hidden ? "none" : undefined,
  };
}
